import React, { memo } from "react";
import {
	Modal, ModalBody, ModalFooter,
	Button
} from "reactstrap";

const SubmitSectionModal = memo( function SubmitSectionModal({
	isOpen, handler, submitResponse
}) {

	const toggle = () => {
		handler(prev => !prev);
	};

	const submitAndShowNext = () => {
		toggle();
		submitResponse();
	};

	return (
		<Modal isOpen={isOpen} size="sm">
			<ModalBody>
				<div>Do you want to submit this section?</div>
			</ModalBody>

			<ModalFooter>
				<Button
					color="secondary"
					className="modalCloseBtn"
					onClick={submitAndShowNext}
				>Yes</Button>
				
				<Button
					color="secondary"
					className="modalCloseBtn"
					onClick={toggle}
				>No</Button>
			</ModalFooter>
		</Modal>
	);
});

export default SubmitSectionModal;